// "use client";

// // ** React Imports
// import { useState, Fragment, useEffect } from "react";

// // ** MUI Imports
// import Box from "@mui/material/Box";
// import IconButton from "@mui/material/IconButton";
// import { styled } from "@mui/material/styles";
// import MuiMenu from "@mui/material/Menu";
// import MuiMenuItem from "@mui/material/MenuItem";
// import Typography from "@mui/material/Typography";

// import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
// import { Avatar } from "@mui/material";
// import { COLORS } from "@/utils/constants/theme/colors";

// // ** Styled Menu component
// const Menu = styled(MuiMenu)(({ theme }) => ({
//   "& .MuiMenu-paper": {
//     width: 400,
//     overflow: "hidden",
//     marginTop: theme.spacing(4),
//     [theme.breakpoints.down("sm")]: {
//       width: "100%",
//     },
//   },
//   "& .MuiMenu-list": {
//     padding: 0,
//   },
// }));

// // ** Styled MenuItem component
// const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
//   paddingTop: theme.spacing(3),
//   paddingBottom: theme.spacing(3),
//   borderBottom: `1px solid ${theme.palette.divider}`,
// }));

// const NotificationDropdown = () => {
//   // ** Props

//   // ** States
//   const [anchorEl, setAnchorEl] = useState(null);

//   const data = [
//     {
//       primaryText: "PrimaryText",
//       secondaryText: "SecondaryText",
//       date: "Today",
//       avatarSrc: "",
//     },
//     {
//       primaryText: "PrimaryText",
//       secondaryText: "SecondaryText",
//       date: "Today",
//       avatarSrc: "",
//     },
//     {
//       primaryText: "PrimaryText",
//       secondaryText: "SecondaryText",
//       date: "Today",
//       avatarSrc: "",
//     },
//     {
//       primaryText: "PrimaryText",
//       secondaryText: "SecondaryText",
//       date: "Today",
//       avatarSrc: "",
//     },
//     {
//       primaryText: "PrimaryText",
//       secondaryText: "SecondaryText",
//       date: "Today",
//       avatarSrc: "",
//     },
//   ];
//   useEffect(() => {
//     Boolean(anchorEl);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [Boolean(anchorEl)]);

//   // ** Vars
//   //   const { direction } = settings;

//   const handleDropdownOpen = (event: any) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleDropdownClose = () => {
//     setAnchorEl(null);
//   };

//   return (
//     <Fragment>
//       <IconButton
//         color="inherit"
//         aria-haspopup="true"
//         onClick={handleDropdownOpen}
//         aria-controls="customized-menu"
//       >
//         <NotificationsNoneOutlinedIcon
//           sx={{ color: "#fff", fontSize: "1.8rem" }}
//         />
//       </IconButton>

//       <Menu
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleDropdownClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//         transformOrigin={{ vertical: "top", horizontal: "left" }}
//         sx={{ border: "3px solid #3CA63C " }}
//       >
//         <MenuItem
//           disableRipple
//           sx={{ backgroundColor: "#272D24 !Important", color: "#E7E3FC" }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               width: "100%",
//             }}
//           >
//             <Typography sx={{ fontWeight: 600 }}>Notifications</Typography>
//           </Box>
//         </MenuItem>

//         {data.map((item, index) => {
//           return (
//             <MenuItem
//               key={`${index}Items`}
//               disableRipple
//               sx={{
//                 backgroundColor: "#272D24 ",
//                 color: "#E7E3FC",
//                 "&:hover": {
//                   backgroundColor: "#272D24 ",
//                   color: "#E7E3FC",
//                   filter: " invert(20%)",
//                 },
//               }}
//             >
//               <NotificationItem data={item} />
//             </MenuItem>
//           );
//         })}
//       </Menu>
//     </Fragment>
//   );
// };

// const NotificationItem = ({ data }: { data: any }) => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         borderBottom: "1px solid rgba(231, 227, 252, 0.12)",
//         p: "1rem",
//         width: "100%",
//       }}
//     >
//       <Box sx={{ mx: "0.5rem", minWidth: "20%" }}>
//         <Avatar />
//         {/* Avatar  */}
//       </Box>
//       <Box sx={{ display: "flex", flexDirection: "column", minWidth: "60%" }}>
//         <Typography
//           sx={{ fontSize: "1.25rem", fontWeight: "600", color: "#FFF" }}
//         >
//           {data.primaryText}
//         </Typography>
//         <Typography
//           sx={{
//             fontSize: "1rem",
//             fontWeight: "400",
//             color: COLORS.adminAppTextPrimary,
//           }}
//         >
//           {data.secondaryText}
//         </Typography>
//       </Box>
//       <Box sx={{ minWidth: "20%", mb: "1rem" }}>
//         <Typography
//           sx={{
//             fontSize: "1rem",
//             fontWeight: "400",
//             color: COLORS.adminAppTextPrimary,
//           }}
//         >
//           {data.date}
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

// export default NotificationDropdown;

"use client"

// ** React Imports
import { useState, Fragment, useEffect } from "react"

// ** MUI Imports
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import { styled } from "@mui/material/styles"
import MuiMenu from "@mui/material/Menu"
import MuiMenuItem from "@mui/material/MenuItem"
import Typography from "@mui/material/Typography"

import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined"
import { Avatar, Link } from "@mui/material"
import { COLORS } from "@/utils/constants/theme/colors"
import { EventLogger } from "@/utils/CommonFunctions"

// ** Styled Menu component
const Menu = styled(MuiMenu)(({ theme }) => ({
  "& .MuiMenu-paper": {
    width: 400,
    overflow: "hidden",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  "& .MuiMenu-list": {
    padding: 0,
  },
}))

// ** Styled MenuItem component
const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

const NotificationDropdown = () => {
  // ** Props

  // ** States
  const [anchorEl, setAnchorEl] = useState(null)

  const data = [
    {
      primaryText: "PrimaryText",
      secondaryText: "SecondaryText",
      date: "Today",
      avatarSrc: "",
    },
    {
      primaryText: "PrimaryText",
      secondaryText: "SecondaryText",
      date: "Today",
      avatarSrc: "",
    },
    {
      primaryText: "PrimaryText",
      secondaryText: "SecondaryText",
      date: "Today",
      avatarSrc: "",
    },
    {
      primaryText: "PrimaryText",
      secondaryText: "SecondaryText",
      date: "Today",
      avatarSrc: "",
    },
    {
      primaryText: "PrimaryText",
      secondaryText: "SecondaryText",
      date: "Today",
      avatarSrc: "",
    },
  ]
  useEffect(() => {
    Boolean(anchorEl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Boolean(anchorEl)])

  // ** Vars
  //   const { direction } = settings;

  const handleDropdownOpen = (event: any) => {
    EventLogger("admin_notification_click")
    setAnchorEl(event.currentTarget)
  }

  const handleDropdownClose = () => {
    setAnchorEl(null)
  }

  return (
    <Fragment>
      <IconButton color="inherit" aria-haspopup="true" onClick={handleDropdownOpen} aria-controls="customized-menu">
        <NotificationsNoneOutlinedIcon sx={{ color: "#fff", fontSize: "1.8rem" }} />
      </IconButton>

      <Menu
        sx={{
          mt: "2rem",
          "& .MuiMenu-list": {
            p: 0,
          },
          "& .MuiMenuItem-root:hover": {
            backgroundColor: "#272D24",
            filter: " invert(20%)",
          },
        }}
        id="menu-appbar"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={false}
      >
        <MenuItem
          sx={{
            backgroundColor: "#272D24",
            p: "0.75rem",
            borderBottom: "1px solid #636363",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
              backgroundColor: "#272D24",
            }}
          >
            <Link href={`/user-profile`} style={{ display: "flex" }}>
              <Typography
                sx={{
                  ml: "1rem",
                  fontWeight: "500",
                  color: COLORS?.adminAppTextPrimary,
                }}
              >
                My Profile
              </Typography>
            </Link>
          </Box>
        </MenuItem>
        <MenuItem
          sx={{
            backgroundColor: "#272D24",
            p: "0.75rem",
            borderBottom: "1px solid #636363",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100%",
              backgroundColor: "#272D24",
            }}
          >
            <Link href={"#"} style={{ display: "flex" }}>
              <Typography
                sx={{
                  ml: "1rem",
                  fontWeight: "500",
                  color: COLORS?.adminAppTextPrimary,
                }}
              >
                Logout
              </Typography>
            </Link>
          </Box>
        </MenuItem>
      </Menu>
    </Fragment>
  )
}

const NotificationItem = ({ data }: { data: any }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid rgba(231, 227, 252, 0.12)",
        p: "1rem",
        width: "100%",
      }}
    >
      <Box sx={{ mx: "0.5rem", minWidth: "20%" }}>
        <Avatar />
        {/* Avatar  */}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: "60%" }}>
        <Typography sx={{ fontSize: "1.25rem", fontWeight: "600", color: "#FFF" }}>{data.primaryText}</Typography>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: "400",
            color: COLORS.adminAppTextPrimary,
          }}
        >
          {data.secondaryText}
        </Typography>
      </Box>
      <Box sx={{ minWidth: "20%", mb: "1rem" }}>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: "400",
            color: COLORS.adminAppTextPrimary,
          }}
        >
          {data.date}
        </Typography>
      </Box>
    </Box>
  )
}

export default NotificationDropdown
